import { connect } from 'react-redux';
import FeedbackFormWorkshop from './components/FeedbackFormWs';
import {
    submitFFForm,
    updateValue,
    updateFormStatus,
    resetFormAction
} from './actions/feedbackFormWsActions';
import { fetchTalkDetails } from '../Program/actions/programActions';

export const mapStateToProps = state => ({
    fields: state.feedbackFormWs.fields,
    formSubmitInProgress: state.feedbackFormWs.formSubmitInProgress,
    formFailed: state.feedbackFormWs.formFailed,
    formSubmitted: state.feedbackFormWs.formSubmitted,
    talksById: state.program.talksById,
    message: state.feedbackFormWs.message
});

export const mapActionCreators = {
    submitFFForm,
    updateValue,
    updateFormStatus,
    resetFormAction,
    fetchTalkDetails
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(FeedbackFormWorkshop);
